<template>
	<aside class="iv2-extra-sns text-center d-xl-block">
		<div v-if="sns.facebook" class="iv2-extra-sns-nav theme-c__extra-sns-bg pt-2">
			<span
				v-if="sns.facebook.status == 0 && sns.instagram.status == 0 && sns.twitter.status == 0 && sns.line.status == 0 && rss.outbound.status == 0"
			></span>
			<span
				v-else
				class="iv2-extra-sns-nav-text theme-c__extra-sns-text d-block text-nowrap"
			>{{ sns_heading }}</span>
			<ul class="iv2-extra-sns-nav-list list-unstyled">
				<li v-if="sns.facebook" class="iv2-extra-sns-nav-item">
					<a
						v-if="sns.facebook.status == 1"
						:href="sns.facebook.url"
						class="iv2-extra-sns-nav-link theme-c__extra-sns-link"
						target="_blank"
						rel="noopener"
					>
						<i class="iv2-extra-sns-nav-item-icon fab fa-facebook-f"></i>
					</a>
				</li>
				<li v-if="sns.instagram" class="iv2-extra-sns-nav-item">
					<a
						v-if="sns.instagram.status == 1"
						:href="sns.instagram.url"
						class="iv2-extra-sns-nav-link theme-c__extra-sns-link"
						target="_blank"
						rel="noopener"
					>
						<i class="iv2-extra-sns-nav-item-icon fab fa-instagram"></i>
					</a>
				</li>
				<li v-if="sns.twitter" class="iv2-extra-sns-nav-item">
					<a
						v-if="sns.twitter.status == 1"
						:href="sns.twitter.url"
						class="iv2-extra-sns-nav-link theme-c__extra-sns-link"
						target="_blank"
						rel="noopener"
					>
						<i class="iv2-extra-sns-nav-item-icon fab fa-twitter"></i>
					</a>
				</li>
				<li v-if="sns.line" class="iv2-extra-sns-nav-item">
					<a
						v-if="sns.line.status == 1"
						:href="sns.line.url"
						class="iv2-extra-sns-nav-link theme-c__extra-sns-link"
						target="_blank"
						rel="noopener"
					>
						<i class="iv2-extra-sns-nav-item-icon fab fa-line"></i>
					</a>
				</li>
				<li v-if="rss.outbound" class="iv2-extra-sns-nav-item">
					<a
						v-if="rss.outbound.status == 1"
						:href="rss.outbound.href"
						class="iv2-extra-sns-nav-link theme-c__extra-sns-link"
						target="_blank"
						rel="noopener"
					>
						<i class="iv2-extra-sns-nav-item-icon fas fa-rss"></i>
					</a>
				</li>
			</ul>
		</div>
	</aside>
</template>

<script>
export default {
	data() {
		return {
			sns: [],
			rss: [],

			sns_heading: "FOLLOW ME"
		};
	},

	created() {
		this.axios.get("/json/settings.json").then(response => {
			this.sns = response.data.settings.sns;
		});
		this.axios.get("/json/rss.json").then(response => {
			this.rss = response.data.rss;
		});
	}
};
</script>

<style lang="scss">
.iv2-extra-sns {
	.iv2-extra-sns-nav {
		margin: 0 40px;
		.iv2-extra-sns-nav-text {
			font-size: 14px;
			font-weight: 600;
			letter-spacing: 2px;
		}

		.iv2-extra-sns-nav-list {
			display: inline-flex;

			.iv2-extra-sns-nav-link {
				margin: 0 10px;
			}

			.iv2-extra-sns-nav-item {
				.iv2-extra-sns-nav-item-icon {
					font-size: 1.2rem;
				}
			}
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-extra-sns {
		.iv2-extra-sns-nav {
			border-top: 1px solid;
		}
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
}

/* SP Only */
@media (max-width: 767px) {
}
</style>
